<template lang="pug">
v-container(style="max-width:960px")
  v-row.mt-sm-5(no-gutters)
    v-col(cols="12" sm="5")
      .d-flex.align-center
        v-text-field(v-model="searchText" @input="queryChanged" :placeholder="$t('search_fundraiser')" hide-details dense outlined height="40" :background-color="$colors.basic200")
          template(v-slot:append)
            eva-icon(name="search-outline" :fill="$colors.primary400")
    v-col(align="end")
      v-btn.button-sm(@click="openAddFundraiserDialog = true" depressed dark color="neutral700") {{ $t('new') }}

  .yc-table
    v-data-table.mt-sm-4.pb-4(:headers="headers" :items="fundraisers" item-key="id" :items-per-page="pageSize" :loading="isLoading" hide-default-footer disable-sort)
      template(v-slot:no-data)
        .mt-16
          v-img.mx-auto(src="@/assets/images/icon_empty.png" width=80)
          .mt-2.p2.basic600--text {{ $t('no_list_available') }}
      template(v-slot:item.name="{ item, isMobile, headers, index }")
        div.font-semibold.py-3 {{ item.user.first_name }} {{ item.user.last_name }}
      template(v-slot:item.email="{ item, isMobile, headers, index }")
        div.table-word-break.py-3 {{ item.user.email }}
      template(v-slot:item.form_slug="{ item, isMobile, headers, index }")
        div.font-semibold.table-word-break.py-3 {{company.slug}}.yezza.co/donation/{{ item.form_slug }}
      template(v-slot:item.raised="{ item, isMobile, headers, index }")
        div.py-3 {{ item.raised | displayPrice }}
      template(v-slot:item.phone="{ item, isMobile, headers, index }")
        div.py-3 {{ item.phone ? `+${item.phone}` : '-' }}
      template(v-slot:item.tier="{ item, isMobile, headers, index }")
        div.text-end.py-3 {{ item.tier ? item.tier.commission_value : '0' }}%
      template(v-slot:item.actions="{ item, isMobile, headers, index }")
        div.py-3
          v-menu(offset-y left rounded="lg")
            template(#activator="{ on }")
              v-btn.ml-4(icon small v-on="on")
                v-icon mdi-dots-horizontal
            v-list(dense min-width="100")
              v-list-item(@click="openEditFundraiser(item)")
                v-list-item-title.text-sm.neutral700--text {{ $t('edit') }}
    .py-4
      yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" :text="$t('show_fundraiser')" @input="pageChanged")

  .dialogs
    edit-fundraiser(v-if="openEditFundraiserDialog" :open.sync="openEditFundraiserDialog" :selectedFundraiser="selectedFundraiser" @closed="closed" @reset="reset")
    add-fundraiser(v-if="openAddFundraiserDialog" :open.sync="openAddFundraiserDialog" @closed="closed" @reset="reset")

</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions } from 'vuex'
import EditFundraiser from '@/components/donation/dialogs/EditFundraiser.vue'
import AddFundraiser from '@/components/donation/dialogs/AddFundraiser.vue'

export default {
  name: 'ManageCampaignFundraiser',
  props: [],
  components: { EditFundraiser, AddFundraiser },
  data: () => ({
    isLoading: false,
    openEditFundraiserDialog: false,
    openAddFundraiserDialog: false,
    searchText: '',
    currentPage: 1,
    pageSize: 20,
    totalCount: 0,
    fundraisers: [],
    selectedFundraiser: null,
    options: [
      {
        text: 'Raised',
        value: 'raised',
        enable: true,
        class: 'text-table-header'
      },
      {
        text: 'Email',
        value: 'email',
        enable: true,
        class: 'text-table-header'
      },
      {
        text: 'Link',
        value: 'form_slug',
        enable: true,
        class: 'text-table-header'
      },
      {
        text: 'Commission',
        value: 'tier',
        enable: true,
        class: 'text-table-header text-end'
      },
      {
        text: '',
        value: 'actions',
        enable: true,
        class: 'text-table-header'
      },
      // {
      //   text: 'Link Click',
      //   value: 'created',
      //   enable: true
      // }
    ],
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      campaign: 'donation/getCampaign'
    }),
    headers: {
      get () {
        const filteredOptions = this.options.filter(item => item.enable)
        const name = {
          text: 'Fundraiser',
          value: 'name',
          class: 'text-table-header'
        }
        return [name, ...filteredOptions]
      }
    },
    isMobileScreen() {
      return this.$vuetify.breakpoint.xs
    }
  },
  watch: {
    pageSize() {
      this.fetchFundraisers(1)
    }
  },
  created() {
    this.fetchFundraisers(1)
  },
  methods: {
    ...mapActions(['showMessage']),
    getFundraisers(page, pageSize, query) {
      const params = {
        page_size: pageSize,
        page,
        search: query || '',
        campaigns: this.campaign.id
      }
      return this.$axios.get(`/donations/${this.company.slug}/fundraisers`, { params })
    },
    fetchFundraisers(page, query) {
      this.isLoading = true
      this.getFundraisers(page, this.pageSize, query)
      .then(resp => {
        const data = resp.data
        this.fundraisers = data.results
        this.fundraisers.map(
          item => {
          item.checked = false
        })
        this.totalCount = data.count
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    pageChanged(num) {
      this.fetchFundraisers(num)
    },
    queryChanged: debounce(function (query) {
      this.fetchFundraisers(1, query)
    }, 750),
    openEditFundraiser (item) {
      this.selectedFundraiser = item
      this.openEditFundraiserDialog = true
    },
    closed () {
      this.selectedFundraiser = null
    },
    reset () {
      this.selectedFundraiser = null
      this.fetchFundraisers(1)
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.table-word-break {
  word-break: break-word;
}
</style>